import { html, View } from 'rune-ts';
import klass from './CardCreatorViewView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font, staticFont } from '@services/MarppleShop/shared/typography';

type TProps =
  | {
      device: 'PC';
      layout: 'List' | 'Detail';
      numbering: string;
      creator_name: string;
      title: string;
      description: string;
      thumbnail: string;
    }
  | {
      device: 'Mobile';
      layout: 'List' | 'Detail';
      numbering: string;
      creator_name: string;
      title: string;
      description: string;
      mobile_thumbnail: string;
    };

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=26352-43078&m=dev
 */
export class CardCreatorViewView extends View<TProps> {
  protected override template(props: TProps) {
    const { device, layout, numbering, creator_name, title, description } = props;

    return html`
      <div class="${klass.card_creator_view}">
        <div class="${klass.creator_view_thumbnail}">
          <img
            alt=""
            src="${props.device === 'Mobile' ? props.mobile_thumbnail : props.thumbnail}"
            class="${classes(klass.thumbnail, {
              [klass.device_pc_layout_list]: device === 'PC' && layout === 'List',
              [klass.device_pc_layout_detail]: device === 'PC' && layout === 'Detail',
              [klass.device_mo_layout_list]: device === 'Mobile' && layout === 'List',
              [klass.device_mo_layout_detail]: device === 'Mobile' && layout === 'Detail',
            })}"
          />

          <div class="${klass.dim}"></div>

          <span
            class="${classes(klass.vol_text, staticFont('bebas_16_bold'), {
              [klass.device_pc_layout_list]: device === 'PC' && layout === 'List',
              [klass.device_pc_layout_detail]: device === 'PC' && layout === 'Detail',
              [klass.device_mo_layout_list]: device === 'Mobile' && layout === 'List',
              [klass.device_mo_layout_detail]: device === 'Mobile' && layout === 'Detail',
            })}"
          >
            VOL.${numbering}
          </span>

          <span
            class="${classes(
              klass.creator_title_text,
              {
                [font('24_bold')]: layout === 'List',
                [font('20_bold')]: layout === 'Detail',
              },
              {
                [klass.device_pc_layout_list]: layout === 'List' && device === 'PC',
                [klass.device_pc_layout_detail]: layout === 'Detail' && device === 'PC',
                [klass.device_mo_layout_list]: device === 'Mobile' && layout === 'List',
                [klass.device_mo_layout_detail]: device === 'Mobile' && layout === 'Detail',
              },
            )}"
          >
            ${html.preventEscape(creator_name)}
          </span>
        </div>

        <div class="${klass.creator_view_title}">
          <p
            class="${classes(klass.monthly_creator_title, {
              [font('16_semibold')]: device === 'PC' && layout === 'List',
              [font('15_semibold')]: device === 'PC' && layout === 'Detail',
              [font('15_semibold')]: device === 'Mobile' && layout === 'List',
              [font('14_semibold')]: device === 'Mobile' && layout === 'Detail',
            })}"
          >
            ${html.preventEscape(title)}
          </p>

          <p class="${classes(klass.monthly_creator_description, font('12_medium'))}">
            ${html.preventEscape(description)}
          </p>
        </div>
      </div>
    `;
  }
}
